module.exports = __webpack_public_path__ + "img/avatar3.d13fe395.png";